export default __webpack_public_path__ + "static/media/grafema_f1rst_05.7d9a0dec.jpg";